<template>
	<div class="slides">
		<div class="slides__content">
			<div class="slides__slide" :class="[{'slides__slide--active': key == activeIdx, }, slide.class]" v-for="(slide, key) in slides" :key="`slide_${key}`" v-html="slide.body" :style="slideStyles(slide)" >
			</div>
		</div>
		<!-- <div class="slides__nav">
			<span class="slides__nav-item" :class="{'slides__nav-item--active': key == activeIdx}" v-for="(slide, key) in slides" :key="`nav_${key}`" @click="activeIdx = key"></span>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'Slides',
	data: () => ({
		activeIdx: 0,
		bgImage: null,
		timer: null,
	}),
	props: {
		slides: {
			type: Array,
			default: () => ([
				{
					body: '<div class="title title--2">Slide 1</div>',
					background: 'filler--jersey.jpg',
					link: '',
				},
				{
					body: '<div class="title title--2">Slide 2</div>',
					background: 'filler--page_header.jpg',
					link: '',
				},
			]),
		},
		interval: {
			type: Number,
			default: 4000,
		},
	},
	computed: {
		contentStyles() {
			const slide = this.slides[this.activeIdx]
			let styles = {}
			if (slide.background) {
				styles['background-image'] = `url(${this.$src(`/assets/${slide.background}`)})`
			}

			return styles
		}
	},
	mounted() {
		this.timer = clearInterval(this.timer)
		this.timer = setInterval(() => {
			if (this.activeIdx == this.slides.length - 1) {
				this.activeIdx = 0
			} else {
				this.activeIdx = this.activeIdx + 1
			}
		}, this.interval)
	},
	unmounted() {
		this.timer = clearInterval(this.timer)
	},
	methods: {
		slideStyles(slide) {
			let styles = {}
			if (slide.background) {
				styles['background-image'] = `linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url(${this.$src(`/assets/${slide.background}`)})`
			}

			return styles
		},
	}
}
</script>

<style scoped lang="scss">
.slides {
	--padding-h: 30px;
	--padding-v: 20px;

	flex: 1;
	position: relative;

	&__content {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		height: 100%;
		position: relative;
	}

	&__slide {
		// bottom: var(--border-radius);
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		flex: 1;
		left: 0;
		opacity: 0;
		padding: var(--padding-v) var(--padding-h);
		// padding: var(--border-radius);
		position: absolute;
		top: 0;
		transition: opacity 500ms ease-out;
		width: 100%;

		&--active {
			opacity: 1;
		}

		.center-content & {
			justify-content: center;
			// padding: var(--border-radius);
		}

		.top-content & {
			justify-content: flex-start;
			// padding: var(--border-radius);
			// padding-bottom: calc(2 * var(--border-radius));
		}

		:deep(span) {
			font-size: 1.125rem;
			font-family: var(--font-family--body);

			@include modules.media-query('phone') {
				font-size: 1rem;
			}
		}

		:deep(.title--5 span) {
			font-family: var(--font-family--serif);
			font-size: var(--font-caption--size);
		}

		// :deep(.ml-auto) {
		// 	@include modules.media-query('tablet') {
		// 		max-width: 100px;
		// 	}
		// }
	}

	&__nav {
		bottom: var(--border-radius);
		display: flex;
		flex-direction: row;
		// display: grid;
		// grid-template-columns: repeat(auto-fit, minmax(min-content, 0.7rem));
		// column-gap: 0.5rem;
		position: absolute;
		left: var(--border-radius);

		.center-nav & {
			padding-left: 0;
			left: 50%;
			transform: translateX(-50%);
			justify-content: center;
			align-items: center;
		}

		&-item {
			color: var(--color--cream);
			cursor: pointer;
			opacity: 0.5;
			transition: opacity 250ms ease-out;
			width: 1.5rem;
			height: 1rem;

			.center-nav & {
				text-align: center;
			}

			&--active {
				opacity: 1;
			}

			&:before {
				content: '\b7\a0';
				display: inline-block;
				font-size: 4rem;
				line-height: 1rem;
				padding-left: 0.5rem;
			}

		}
	}
}
</style>
